import React from 'react';
import { LinkProps } from './link.types';
import * as S from './link.styles';
import { useRef } from 'react';
import { useLink } from 'react-aria';
import { useFocusRing, mergeProps } from 'react-aria';

export const Link = <C extends React.ElementType = 'a'>({
  href,
  children,
  variant = 'default',
  size = 16,
  className,
  as,
  ...restProps
}: LinkProps<C>) => {
  const ref = useRef<HTMLAnchorElement>(null);

  const { linkProps } = useLink({ href }, ref);
  const { isFocusVisible, focusProps } = useFocusRing();

  const Component = as || 'a';

  return (
    <S.Link
      ref={ref}
      as={Component}
      href={href}
      variant={variant}
      size={size}
      isFocusVisible={isFocusVisible}
      className={className}
      data-testid="link"
      {...mergeProps(linkProps, focusProps, restProps as object)}
    >
      {children}
    </S.Link>
  );
};
